import AnalyticsChart from "./analytics-chart";

export default AnalyticsChart;